import { Switch as AntSwitch, type SwitchProps } from 'antd';
import type { FC } from 'react';

type Props = Pick<SwitchProps, 'checked' | 'onChange' | 'disabled'> & {
  checkedLabel?: string;
  unCheckedLabel?: string;
};

export const Switch: FC<Props> = ({
  checkedLabel,
  unCheckedLabel,
  disabled,
  ...rest
}) => {
  return (
    <AntSwitch
      {...rest}
      checkedChildren={checkedLabel}
      unCheckedChildren={unCheckedLabel}
      disabled={disabled}
      data-dd-privacy="allow"
    />
  );
};
